import styled from 'styled-components';
import woman from './images/womanForm.png';

export const HeadingText = styled.div`
  font-weight: 300;
  font-size: 26px;
  line-height: 25px;
  color: rgb(128, 128, 128);
  span {
    font-weight: 500;
    color: #000;
  }

  @media (max-width: 760px) {
    font-size: 20px;
    span {
      display: block;
    }
  }
  @media (max-width: 420px) {
    font-size: 16px;
  }
`;
export const ActionText = styled.div`
  margin-top: 10px;
  font-weight: 300;
  font-size: 16px;
  line-height: 18px;

  @media (max-width: 760px) {
    font-size: 14px;
  }
`;

export const WomanImg = styled.img.attrs({
  src: `${woman}`,
})`
  width: 70px;
  height: 70px;
  margin-right: 10px;
  display: none;

  @media (max-width: 660px) {
    display: block;
  }
`;
